import {
  canAnyPermission,
  updateAbility,
} from "@/abilities/ability";
import { authCookies } from "@/services/cookies";
import i18n from "../../i18n";
import toast from "@/plugins/toast";

const deny = (next) => {
  toast(i18n.global.t("You are not authorized to access this page"), {
    type: "error",
  });
  return next(false);
};

const resolvePermissions = (meta = {}) => {
  if (meta.action && meta.subject) {
    return [{ action: meta.action, subject: meta.subject }];
  }

  const permission = meta.permission;
  if (!permission) return [];

  return Array.isArray(permission) ? permission.filter(Boolean) : [permission];
};

export default function isAuthorized({ next, to }) {
  updateAbility(authCookies.getPermissions());

  const allowedTypes = to?.meta?.types;
  if (Array.isArray(allowedTypes) && allowedTypes.length) {
    const user = authCookies.getUser();
    if (!allowedTypes.includes(user?.type)) {
      return deny(next);
    }
  }

  const permissions = resolvePermissions(to?.meta);

  if (!permissions.length) {
    return next();
  }

  if (!canAnyPermission(permissions)) {
    return deny(next);
  }

  return next();
}
